export default __webpack_public_path__ + "static/media/HaydnKlangspiel.7ad6db56.jpg";